import { MatchingProfileSettings } from "@/components/settings/matching-profile-settings";
import {
  useMentorProfileReview,
  type MentorProfileReviewStatus,
} from "@/lib/api/mentor-profile";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";
import { useEffect, useRef } from "react";

const SUBMITTED_STATUSES: ReadonlySet<MentorProfileReviewStatus> = new Set([
  "submitted",
  "in_review",
]);

export function SelfMatchingProfileTab() {
  useTrackSelfProfileSubmit();
  return <MatchingProfileSettings hidePageHeading />;
}

function useTrackSelfProfileSubmit() {
  const { data: review } = useMentorProfileReview();
  const { track } = useTrackEvent();
  const previousStatus = useRef<MentorProfileReviewStatus | undefined>(
    undefined,
  );

  useEffect(() => {
    const status = review?.status;
    const previous = previousStatus.current;
    previousStatus.current = status;

    if (!status || !previous || previous === status) return;
    if (!SUBMITTED_STATUSES.has(status)) return;
    if (SUBMITTED_STATUSES.has(previous)) return;

    track(PostHogEvents.SELF_RECORD_PROFILE_CHANGE_REQUESTED);
  }, [review?.status, track]);
}
